module.exports = __webpack_public_path__ + "static/img/water-left.30350b73.png";